import type { PolicyUpdate, Profile } from "@contracts";

const scoreFor = (policyId: string, profile: Profile) => {
  if (policyId === "POL-WORK-001" && profile.employment === "employee") return {score: 3, reason: "근로자 조건 때문에 관련"};
  if (policyId.startsWith("POL-PENSION") && profile.pensionCovered === true) return {score: 3, reason: "국민연금 가입 조건 때문에 관련"};
  if (policyId === "POL-CARE-001" && ((profile.childrenCount ?? 0) > 0 || profile.employment === "caregiver")) return {score: 3, reason: "자녀·돌봄 조건 때문에 관련"};
  return {score: 0, reason: "내 조건을 더 고르면 관련성을 확인할 수 있어요"};
};

export function briefPolicyUpdates(updates: PolicyUpdate[], profile: Profile) {
  return updates.map((update) => ({...update, ...scoreFor(update.policyId, profile)})).sort((a, b) => b.score - a.score || b.happenedAt.localeCompare(a.happenedAt));
}
